import { HttpClient } from '@angular/common/http'
import { Injectable, signal } from '@angular/core'
import { Observable, tap } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CompanyProfileService {
  companyProfileSignal = signal<any | null>(null)

  constructor(private http: HttpClient) {}

  getCompanyProfile(): Observable<any> {
    return this.http.get(`Company/GetProfile`).pipe(
      tap((res: any) => {
        if (res?.Data && !res.Data?.IsError) {
          this.companyProfileSignal.set(res.Data)
        }
      })
    )
  }

  updateCompanyProfile(body: any): Observable<any> {
    return this.http.put(`Company/Profile`, body).pipe(
      tap((res: any) => {
        if (res?.Data && !res.Data?.IsError) {
          this.getCompanyProfile().subscribe()
        }
      })
    )
  }
}
